import { Box } from '@wix/design-system';
import {
  EnrichedProduct,
  RecommendedContent,
} from '@wix/package-picker-common';
import {
  Price,
  ProductHat,
  ProductTitle,
  ProductsGrid,
  SelectProductButton,
} from '@wix/package-picker-components';
import classNames from 'classnames';
import { PaymentCycle, ProductFamily } from 'enums';
import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './GridHeader.scss';

interface GridHeaderProps {
  product: EnrichedProduct;
  recommendedContent?: RecommendedContent;
  onClickSelect: () => void;
}

export const GridHeader: React.FC<GridHeaderProps> = ({
  product,
  recommendedContent,
  onClickSelect,
}) => {
  const { t } = useTranslation();
  // TODO: change to dynamic values
  const pricesIncludeTax = !!product.pricingInfo?.priceIncludesTax;
  const displayPrices =
    product.pricingInfo?.displayPrices?.[PaymentCycle.YEARLY].monthly;
  const price = (displayPrices?.price ?? 0) / 100;
  const fullPrice = (displayPrices?.fullPrice ?? 0) / 100;
  const isInSale = fullPrice !== price;
  const isEnterpriseProduct =
    product.productFamily === ProductFamily.Enterprise;
  const isDisabled = false;

  if (!price || !fullPrice) {
    // TODO: Handle no price
    // return <></>;
  }

  return (
    <ProductsGrid.Header.Cell
      className={classNames(s.headerCell, {
        [s.sale]: isInSale,
        [s.tax]: pricesIncludeTax,
        // [s.anonymous]: isAnonymous,
      })}
    >
      <Box margin='6px' height='24px'>
        {recommendedContent && (
          <ProductHat hatText={recommendedContent?.text} />
        )}
      </Box>
      <Box align='center'>
        {product.name && <ProductTitle title={product.name} />}
      </Box>
      <Box verticalAlign='middle'>
        {!isEnterpriseProduct && (
          <Price
            fullPrice={fullPrice}
            price={price}
            size='small'
            cycleLabel={`/${t('product_price.month')}`}
            taxIncludedLabel='TODO2'
            shouldShowProductFullPrice={isInSale}
            shouldShowTaxIncludedLabel={pricesIncludeTax}
          />
        )}
      </Box>
      <Box className={s.cta} width='80%' align='center'>
        <SelectProductButton
          text={
            isEnterpriseProduct
              ? t('premium-purchase-plan.cards.enterprise.cta', 'Contact Us')
              : t('productEntry.select', 'Select')
          }
          onClick={onClickSelect}
          disabledText={t(
            'Advanced.Plans_second.upgrade_plan.disabled.tooltip',
          )}
          disabled={isDisabled}
          size='small'
          priority={recommendedContent ? 'primary' : 'secondary'}
          fullWidth
        />
      </Box>
    </ProductsGrid.Header.Cell>
  );
};
